<template>
  <van-popup v-model="show" :overlay="false">
    <div class="group-buy-QRCode-dialog">
      <header>
        <img src="../../../../assets/img/public/popup_close.png" alt="关闭" @click="close"/>
      </header>
      <div id="qrCode">
        <div id='code'></div>
        <canvas id="canvas"></canvas>
      </div>
      <div class="content">
        用手机微信扫一扫二维码，参与我的拼团
      </div>
    </div>
  </van-popup>
</template>

<script>
import QRCode from 'qrcode';

export default {
  name: 'GroupBuyQRCodeDialog',
  props: {
    url: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      msg: 'hello vue',
      codes: '',
      show: false,
    };
  },

  components: {
    // eslint-disable-next-line vue/no-unused-components
    QRCode,
  },

  methods: {
    close() {
      this.show = false;
    },
    codeInit() {
      const canvas = document.getElementById('canvas');
      QRCode.toCanvas(canvas, this.url, (error) => {
        if (error) console.error(error);
      });
    },
  },

  mounted() {

  },

  watch: {
    show(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.codeInit();
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.group-buy-QRCode-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 624px;
  min-height: 500px;
  padding: 36px;

  header{
    display: flex;
    justify-content: flex-end;
    width: 100%;
    text-align: right;
    img{
      width: 29px;
      height: 29px;
    }
  }

  .content {
    color: #333;
    font-weight: 600;
    font-size: 29px;
    line-height: 40px;
  }
}
</style>
